import { useEffect } from 'react'

import { Box, Button, Spinner } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { useSyncValidation } from 'modules/integrations/hooks/SyncContext/useSyncValidation'
import Callout from 'modules/core/components/Callout'
import Unavailable from './Unavailable'

interface ErrorMessage {
  key: string
  value: string
}

interface Props {
  integrationName: string
  errorMessages: ErrorMessage[]
  onSync: () => Promise<void>
  syncing: boolean
}

const Failed = ({ integrationName, errorMessages, onSync, syncing }: Props) => {
  const { fetchIssues, issues, issuesLoading } = useSyncValidation()

  useEffect(() => {
    fetchIssues()
  }, [fetchIssues])

  if (issuesLoading) {
    return (
      <Box width="full" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  if (issues.length > 0) {
    return <Unavailable issues={issues} />
  }

  return (
    <Callout
      type="critical"
      title={i18n.t('payroll_integrations.employee_update_leave.failed.title', {
        integration_name: integrationName,
      })}
      description={errorMessages.map((error) => error.value).join('. ')}
      link={
        <Button onClick={onSync} disabled={syncing}>
          {i18n.t('payroll_integrations.employee_update_leave.failed.submit')}
        </Button>
      }
    />
  )
}

export default Failed
